
import { Card, CardContent } from "@/components/ui/card";
import { Phone, Video, FileText, GraduationCap, Clock } from "lucide-react";
import { useIntersectionObserver } from "@/hooks/use-intersection-observer";

const ProcessSection = () => {
  const { elementRef: titleRef, isVisible: titleVisible } = useIntersectionObserver();
  const { elementRef: stepsRef, isVisible: stepsVisible } = useIntersectionObserver();
  const { elementRef: footerRef, isVisible: footerVisible } = useIntersectionObserver();

  const steps = [
    {
      number: "1",
      icon: Phone,
      title: "Premier échange téléphonique",
      description: "pour comprendre votre projet"
    },
    {
      number: "2", 
      icon: Video,
      title: "Visioconférence",
      description: "avec Nicolas, CEO de Work&You"
    },
    {
      number: "3",
      icon: FileText,
      title: "Réception du contrat",
      description: "de partenariat affilié"
    },
    {
      number: "4",
      icon: GraduationCap,
      title: "Formation initiale",
      description: "et démarrage de votre activité"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div 
          ref={titleRef}
          className={`text-center mb-16 transition-all duration-800 ${
            titleVisible ? 'animate-slide-in-up' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Quel est le <span className="gradient-text">processus de recrutement</span> ?
          </h2>
        </div>

        <div className="max-w-6xl mx-auto">
          <div 
            ref={stepsRef}
            className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12"
          >
            {steps.map((step, index) => (
              <Card 
                key={index} 
                className={`group hover:shadow-xl transition-all duration-500 relative overflow-hidden ${
                  stepsVisible 
                    ? `animate-slide-in-up animate-stagger-${index + 1}` 
                    : 'opacity-0 translate-y-10'
                }`}
              >
                <div className="absolute top-0 right-0 w-16 h-16 gradient-bg transform rotate-45 translate-x-8 -translate-y-8 group-hover:scale-110 transition-transform duration-300"></div>
                <CardContent className="p-8 text-center relative">
                <div className="absolute top-4 right-4 text-2xl font-bold text-primary z-10 bg-white rounded-full w-8 h-8 flex items-center justify-center">
                  {step.number}
                </div>
                  <div className="w-16 h-16 mx-auto rounded-2xl bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors duration-300">
                    <step.icon className="w-8 h-8 text-primary" />
                  </div>
                  <h3 className="text-xl font-bold mb-4 text-gray-900">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          <Card 
            ref={footerRef}
            className={`bg-gradient-to-r from-primary/5 to-secondary/5 border-2 border-primary/20 transition-all duration-800 ${
              footerVisible ? 'animate-scale-in' : 'opacity-0 scale-95'
            }`}
          >
            <CardContent className="p-8 text-center">
              <div className="flex items-center justify-center mb-6">
                <Clock className="w-8 h-8 text-primary mr-3" />
                <h3 className="text-2xl font-bold text-gray-900">Processus ultra-rapide</h3>
              </div>
              <p className="text-xl text-gray-700 leading-relaxed">
                ⏱️ <strong>Moins de 7 jours</strong> entre votre candidature et votre intégration
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
